import styled from 'styled-components';
import { StyledButton } from '../Button/styled';
import { StyledFieldInput } from '../Field/FieldInput/styled';

export const StyledInputGroup = styled.div`
  display: flex;

  ${StyledFieldInput} {
    box-shadow: ${(p) => p.theme.shadows.y}, ${(p) => p.theme.shadows.left};
    border-radius: ${(p) => p.theme.radii.pill} 0 0 ${(p) => p.theme.radii.pill};
  }

  ${StyledButton} {
    border-radius: 0 ${(p) => p.theme.radii.pill} ${(p) => p.theme.radii.pill} 0;
  }
`;
